// src/components/Rates.js
import React, { useEffect, useRef } from "react";
import "../styles/rates.css";

/**
 * IMPORTANT:
 * - This file uses *default export* at the bottom.
 * - Keep the file name/casing EXACTLY: Rates.js
 * - Make sure /src/styles/rates.css exists and has valid CSS (below).
 */

const VEHICLE_RATES = [
  {
    id: "wagonr",
    name: "Wagon R (Hatchback)",
    dropRatePerKm: 140,              // your provided drop rate
    hourlyRate: 300,                // fill/change as you like
    outstationPerKm: 70,             // fill/change as you like
    img: "/assets/wagonr.webp",
  },
  {
    id: "prius",
    name: "Toyota Prius (Sedan)",
    dropRatePerKm: 160,
    hourlyRate: 300,
    outstationPerKm: 80,
    img: "/assets/prius.png",
  },
  {
    id: "vezel",
    name: "Honda Vezel (SUV)",
    dropRatePerKm: 160,
    hourlyRate: 300,
    outstationPerKm: 90,
    img: "/assets/vezel.png",
  },
  {
    id: "van",
    name: "Passenger Van (Hiace)",
    dropRatePerKm: 260,
    hourlyRate: 300,
    outstationPerKm: 140,
    img: "/assets/hiace.png",
  },
];

export default function Rates() {
  const sectionRef = useRef(null);

  // Simple scroll-reveal animation
  useEffect(() => {
    const cards = sectionRef.current?.querySelectorAll(".rate-card");
    if (!cards?.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("reveal");
        });
      },
      { threshold: 0.15 }
    );

    cards.forEach((c) => observer.observe(c));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="rates-page" ref={sectionRef}>
      <h1>Our Rates & Packages</h1>
      <p className="tagline">Transparent pricing — no hidden charges, no surge fees.</p>

      <div className="rate-grid">
        {VEHICLE_RATES.map((v) => (
          <article key={v.id} className="rate-card hidden" role="group" aria-label={v.name}>
            <img
              src={process.env.PUBLIC_URL + v.img}
              alt={v.name}
              className="rate-img"
              loading="lazy"
            />
            <h2 className="rate-title">{v.name}</h2>

            <ul className="rate-list">
              <li>
                <span>Drop Rate (City)</span>
                <strong>Rs {v.dropRatePerKm}/km</strong>
              </li>
              <li>
                <span>Hourly Rate</span>
                <strong>Rs {v.hourlyRate}/hr</strong>
              </li>
              <li>
                <span>Up & Down</span>
                <strong>Rs {v.outstationPerKm}/km</strong>
              </li>
            </ul>
          </article>
        ))}
      </div>

      <div className="rate-notes">
        <p>🚖 Rates may vary based on fuel price and route. Tolls/parking are charged at cost.</p>
        <p>🕒 Waiting charges may apply for extended stops or delays.</p>
      </div>

      {/* OPTIONAL: quick packages block you can fill later
      <div className="packages">
        <h3>Popular City & Airport Packages</h3>
        <ul>
          <li>Kurunegala → BIA (Wagon R): <strong>Rs 12,000</strong></li>
          <li>Kurunegala → Colombo (Prius): <strong>Rs 11,500</strong></li>
          <li>Kurunegala → Kandy (Vezel): <strong>Rs 10,000</strong></li>
          <li>Kurunegala → Anuradhapura (Hiace): <strong>Rs 16,000</strong></li>
        </ul>
      </div>
      */}
    </section>
  );
}
